import { parse, stringify } from "jsurl2"

export function encodeObj(obj: any): string {
  return encodeURIComponent(stringify(obj))
}

export function decodeObj(value: string): any {
  return parse(decodeURIComponent(value))
}
